import {Company} from '../../company/models/company.models';

export const ROLE_ADMIN = 'admin';
export const ROLE_MANAGER = 'manager';
export const ROLE_USER = 'user';

export class CurrentUser {
    /** @type {string} */
    userId = '';

    /** @type {string} */
    role = '';

    /** @type {string} */
    name = '';

    /** @type {string} */
    surname = '';

    /** @type {string} */
    username = '';

    /** @type {string} */
    email = '';

    /** @type {Company|null} */
    company = null;

    /** @type {string} */
    passwordChangedAt = '';
    
    /** @type {Boolean} */
    requiresPasswordChange = false;
    /**
     * @param {Object} obj
     * @returns {CurrentUser}
     */
    static fromArray(obj) {
        if (obj.company) {
            obj.company = Company.fromArray(obj.company);
        }

        return Object.assign(new this, obj || {});
    }

    get isAdmin() {
        return this.role === ROLE_ADMIN;
    }

    get isManager() {
        return this.role === ROLE_MANAGER;
    }

    get isUser() {
        return this.role === ROLE_USER;
    }

    get hasOutdatedPassword() {
        const passwordDate = new Date(
            new Date(this.passwordChangedAt).getFullYear(),
            new Date(this.passwordChangedAt).getMonth(),
            new Date(this.passwordChangedAt).getDate()
        );

        const threeMonthsPast = new Date(new Date().getFullYear(), new Date().getMonth() - 3, new Date().getDate());

        return passwordDate < threeMonthsPast;
    }
}